import { Box } from "@mui/material";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const retireeStepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

const heirStepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "添付書類の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: "あなたの情報を入力してください",
  },
  {
    keyword: "retireeName",
    type: "contractorAndNumber",
    contractorName: "退職者名",
    showLine: false,
  },
  {
    title: "氏名",
    keyword: "staffNameKanji",
    type: "name",
    requiredIcon: true,
    helpicon: true,
    helpText: "被共済職員の氏名です。",
    disabled: true,
  },
  {
    title: "現住所",
    keyword: "currentAddress",
    type: "locationGroup",
    requiredIcon: true,
    helpicon: true,
    helpText: "被共済職員の現在の住所地です。",
    disabled: true,
  },
  {
    title: "個人番号",
    keyword: "myNumber",
    type: "text",
    text: "別添の個人番号確認書類のとおり",
  },
  {
    title: "その年１月１日現在の住所（郵便番号）",
    keyword: "retirementYearFirstZipcode",
    type: "addressSearch",
    requiredIcon: true,
  },
  {
    title: "その年１月１日現在の住所",
    keyword: "address",
    type: "locationGroup",
    requiredIcon: true,
    helpicon: true,
    helpText: "退職する年の１月１日現在の住民登録をしていた住所地です",
    disabled: true,
    inputProps: { maxLength: 85 },
  },
  {
    keyword: "info",
    type: "node",
    node: (
      <Box width="100%" justifyContent="flex-end" display="flex">
        【個人番号の取得目的】あなたの個人番号は税務手続きに利用します。
      </Box>
    ),
  },
];

const schema = {
  retirementYearFirstZipcode: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  address: {
    validate: (data: any) => {
      let error = {
        prefectures: "",
        city: "",
        address: "",
      };

      error = {
        prefectures: !data?.prefectures
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : "",
        city: !data?.city ? TkPropertyMessageGet("TKMSG_SCR0043E") : "",
        address: !data?.address
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : // eslint-disable-next-line no-control-regex
          !data.address?.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : data.address?.length > 85
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "85")
          : "",
      };

      if (
        error.prefectures !== "" ||
        error.city !== "" ||
        error.address !== ""
      ) {
        return JSON.stringify(error);
      }
    },
  },
};

export { retireeStepper, heirStepper, fakeTableList, schema };
